import React, { createContext, memo, useContext } from 'react';

import PropTypes from 'prop-types';

import { ChildrenPropType } from '../../prop-types/children';

const FulfillmentPlanIdContext = createContext(undefined);

export const useFulfillmentPlanIdContext = () => useContext(FulfillmentPlanIdContext);

const FulfillmentPlanIdContextProvider = ({ fulfillmentPlanId, children }) => (
  <FulfillmentPlanIdContext.Provider value={fulfillmentPlanId}>{children}</FulfillmentPlanIdContext.Provider>
);

export default memo(FulfillmentPlanIdContextProvider);

FulfillmentPlanIdContextProvider.propTypes = {
  fulfillmentPlanId: PropTypes.string,
  children: ChildrenPropType.isRequired,
};
